import { useMemo } from 'react';
import TextWinds from '../../../components/common/TextWinds';
import { useAppSelector } from '../../../store/hook';
import { selectLmsLists } from '../../../store/features/lmsSlice';
import {
  AssignmentType,
  CourseId,
  LmsLinkItemKey,
} from '../../../constants/types/lms/type';
import CreateAssignmentBasicWrapper from '../../../components/lms/assignment/create/CreateAssignmentBasicWrapper';
import CreateAssignmentWmwWrapper from '../../../components/lms/assignment/create/CreateAssignmentWmwWrapper';
import CreateAssignmentHfhjWrapper from '../../../components/lms/assignment/create/CreateAssignmentHfhjWrapper';
import { AssignmentItem } from '../../../constants/types/lms/assignment/type';
import LmsGuideButton from '../../../components/lms/LmsGuideButton';

type Book = {
  id: string;
  title: string;
  type: AssignmentType;
};

type Lesson = {
  id: string;
  bookId: string;
  title: string;
};

export type LessonWithAssignments = Lesson & {
  assignments?: AssignmentItem[];
  isAssignmentLoaded?: boolean;
};

export type BookNode = Book & {
  lessons?: LessonWithAssignments[];
  isLessonLoaded?: boolean;
  assignments?: AssignmentItem[];
  isAssignmentLoaded?: boolean;
};

export type SelectedAssignment = AssignmentItem & {
  bookTitle: string;
  lessonTitle?: string;
};

/**
 * 개편 LMS (교사) - 과제 관리 > 과제 내주기 페이지 > 상단 & 콘텐츠
 */
const CreateAssignment = () => {
  const lmsLists = useAppSelector(selectLmsLists);

  const courseType = useMemo(() => {
    switch (lmsLists.course.id) {
      case CourseId.BASIC:
        return 'BASIC';
      case CourseId.WMW:
        return 'WMW';
      case CourseId.HFHJ:
        return 'HFHJ';
      default:
        return null;
    }
  }, [lmsLists]);

  return (
    <div className="flex w-full flex-col pt-6 xl:px-5">
      <header className="flex flex-col gap-3 px-5 xl:flex-row xl:items-center xl:justify-between xl:px-0">
        <div className="min-w-0">
          <TextWinds type="title_h2" xlType="title_h3" className="mb-[2px]">
            과제 내주기
          </TextWinds>

          <TextWinds type="content_body3">
            학생에게 {`${courseType === 'BASIC' ? '젭스온' : '젭스플'}`} 과제를
            등록해 주세요. 학생은 본인 계정으로 접속하여&nbsp;
            {`${courseType === 'BASIC' ? '젭스온' : '젭스플'}`}을 이용할 수
            있습니다.
          </TextWinds>
        </div>

        <LmsGuideButton itemKey={LmsLinkItemKey.TODO_ASSIGN} />
      </header>

      {/* WMW 은 데이터 구조가 달라서 컴포넌트 분리함 */}
      {courseType === 'BASIC' && <CreateAssignmentBasicWrapper />}
      {courseType === 'WMW' && <CreateAssignmentWmwWrapper />}
      {courseType === 'HFHJ' && <CreateAssignmentHfhjWrapper />}
    </div>
  );
};

export default CreateAssignment;
